import { cn } from '@/lib/utils'
import { forwardRef } from 'react'

export const Input = forwardRef(function Input({ className, ...props }, ref) {
  return (
    <input
      ref={ref}
      className={cn(
        'w-full bg-surface-raised border border-border rounded-lg px-3 h-8 text-sm text-text',
        'placeholder:text-text-faint focus:outline-none focus:border-accent/50 focus:ring-1 focus:ring-accent/30 transition-colors',
        className
      )}
      {...props}
    />
  )
})
